
export function background() {
    $('.home .navbar-toggler').on('click', function() {
        console.log('click');
        $('nav.navbar')
            .toggleClass('bg-transparent')
            .toggleClass('bg-dark');
    });
}


